export class Slick {

    constructor() {
        this.initSlick();
    }

    initSlick() {
        $('.slider-three').slick({
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            centerMode: true,
            variableWidth: true,
            prevArrow: '<a class="slick-arrow-prev" href="#"><i class="icon icon-chevron" aria-hidden="true"></i></a>',
            nextArrow: '<a class="slick-arrow-next" href="#"><i class="icon icon-chevron" aria-hidden="true"></i></a>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
}



// WEBPACK FOOTER //
// ./src/Frontend/Themes/Custom/src/Js/Theme/Slick.js